import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import { MSEnum } from '@/commons/enumeration';
class UserAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "TaskGo";
  controllerName = 'Users';

  /**
   * Gửi mail kích hoạt người dùng
   * VDGiang 31/3/2022
   */
  sentMailActiveUser(payload) {
    let request = {
      url: this.getAPIUrl() + "/sendEmail",
      data: payload
    };

    return httpClient.postAsync(request);
  }

  /**
   * Them/Sua/Xoa nhieu
   * @param {*} payload
   * @returns
   * CreateBy: VDGiang 31/3/2022
   */
  async multiSubmit(payload) {
    let request = {
      url: this.getAPIUrl() + "/submit",
      data: payload
    };

    return await httpClient.postAsync(request, true);
  }

  /**
   * Hàm thêm mới người dùng
   * VDGiang 31/3/2022
   * @param {*} model 
   * @returns 
   */
  saveUserApi(model) {
    let request = {
      url: this.getAPIUrl(),
      data: {
        ignores: [],
        model: model,
        returnRecord: true
      }
    }
    if (model.State == MSEnum.ModelState.Update) {
      return httpClient.putAsync(request);
    }
    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy template mẫu cho object user
   * vdgiang(30/3/2023)
   * @param {*} payload 
   * @returns 
   */
  getUserNew(payload) {
    let request = {
      url: this.getAPIUrl() + `/new`
    }
    return httpClient.getAsync(request)
  }

  /**
   * Hàm lấy 1 người dùng
   * vdgiang(30/3/2023)
   * @param {*} id 
   * @returns 
   */
  getUserByID(id) {
    let request = {
      url: this.getAPIUrl() + `/edit/${id}`
    }
    return httpClient.getAsync(request)
  }

  /**
   * Lấy danh sách người dùng dựa theo người dùng hiện tại
   * @param {number} skip skip
   * @param {number} take take
   * @param {string} filter filter
   * @param {string} sort sort
   * @param {boolean} isGetPeopleInvolved có lấy người liên quan ko
   * @returns Danh sách người dùng dựa theo người dùng hiện tại
   * @author: BMThang(12/12/2022)
   */
  getPagingUserWithAuth(
    skip = 0,
    take = 15,
    filter = '',
    sort = '',
    isGetPeopleInvolved = false
  ) {
    let request = {
      url: `${this.getAPIUrl()}/GetPagingUserWithAuth`,
      data: {
        skip,
        take,
        filter,
        sort,
        isGetPeopleInvolved,
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách người dùng cho ủy quyền
   * @param {number} skip skip
   * @param {number} take take
   * @param {string} filter filter
   * @param {string} sort sort
   * @param {boolean} isGetPeopleInvolved có lấy người liên quan ko
   * @returns Danh sách người dùng dựa theo người dùng hiện tại
   * @author: pqhieu(21/12/2022)
   */
  getPagingUserForAuthorization(
    skip = 0,
    take = 15,
    filter = '',
    sort = '',
    listUser
  ) {
    let request = {
      url: `${this.getAPIUrl()}/GetPagingUserForAuthorization`,
      data: {
        skip,
        take,
        filter,
        sort,
        listIDs: listUser,
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy số người dùng dựa theo người dùng hiện tại
   * @param {string} filter filter
   * @param {boolean} isGetPeopleInvolved có lấy người liên quan ko
   * @returns Số người dùng dựa theo người dùng hiện tại
   * @author: pqhieu(21/12/2022)
   */
  getPagingUserForAuthorizationSummary(filter = '', listUser) {
    let request = {
      url: `${this.getAPIUrl()}/GetPagingUserForAuthorizationSummary`,
      data: {
        filter,
        listIDs: listUser,
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy số người dùng dựa theo người dùng hiện tại
   * @param {string} filter filter
   * @param {boolean} isGetPeopleInvolved có lấy người liên quan ko
   * @returns Số người dùng dựa theo người dùng hiện tại
   * @author: BMThang(12/12/2022)
   */
  getPagingUserWithAuthSummary(filter = '', isGetPeopleInvolved = false) {
    let request = {
      url: `${this.getAPIUrl()}/GetPagingUserWithAuthSummary`,
      data: {
        filter,
        isGetPeopleInvolved,
      },
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách người dùng
   * @param {number} skip skip
   * @param {number} take take
   * @param {string} filter filter
   * @param {string} sort sort
   * @param {string} columns danh sách cột lấy về
   * @param {string} emptyFilter emptyFilter
   * @returns Danh sách người dùng
   * @author: VDGiang(1/2/2022)
   */
  getPaging(param) {
    let request = {
      url: `${this.getAPIUrl()}/list`,
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách người dùng
   * @param {number} skip skip
   * @param {number} take take
   * @param {string} filter filter
   * @param {string} sort sort
   * @param {string} columns danh sách cột lấy về
   * @param {string} emptyFilter emptyFilter
   * @returns Danh sách người dùng
   * @author: VDGiang(1/2/2022)
   */
  getTotal(param) {
    let request = {
      url: `${this.getAPIUrl()}/list-summary`,
      data: param
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy danh tab màn tổng quan
   * @returns Danh tab màn tổng quan
   * @author: BMThang(23/02/2023)
   */
  getDashboardTabs() {
    let request = {
      url: `${this.getAPIUrl()}/DashboardTabs`,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy danh sách người dùng có thể bàn giao
   * vdhuy
   */
  getUserToHandover(payload) {
    let request = {
      url: `${this.getAPIUrl()}/GetUserToHandover`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra kết nối tới QLCB
   * @param {*} payload
   * NMTUAN2 11.02.2022
   */
  checkConnectionToQLCB(payload) {
	  let request = {
	    url: this.getAPIUrl() + "/check-connection-to-QLCB",
	    data: payload,
	    timeout: window._appConfig.importTimeout,
	  };
	  return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu hồ sơ cá nhân từ QLCB
   * @param {*} payload
   * VDGiang 23.05.2023
   */
  getEmployeeFromQLCB(payload) {
    let request = {
      url: this.getAPIUrl() + "/employee-from-QLCB",
      data: payload,
      timeout: window._appConfig.connectQLCBTimeout,
    };
  
    return httpClient.postAsync(request);
  }
  
  /**
   * Lấy dữ liệu hồ sơ cá nhân từ QLCB
   * @param {*} payload
   */
  getDepartmentFromQLCB(payload) {
    let request = {
      url: this.getAPIUrl() + "/department-from-QLCB",
      data: payload,
      timeout: window._appConfig.connectQLCBTimeout,
    };
    
    return httpClient.postAsync(request);
  }
  

  checkExistEmail(payload) {
    let request = {
      url: this.getAPIUrl() + '/check-exist-email',
      data: payload,
    }

    return httpClient.postAsync(request);
  }
    
  saveMultiUser(payload) {
    let request = {
      url: this.getAPIUrl() + "/save-multi-user",
      data:payload
    }
    
    return httpClient.postAsync(request);
  }

  
}

export default new UserAPI();
